<template lang="pug">
el-dialog.edit-memo-dialog(
  title="修改"
  :visible.sync="dialogVisible"
  width="50%"
  :close-on-click-modal="false"
  :before-close='handleClose')
  el-form(:model='form' :rules='rules' size='small' label-width='90px' :hide-required-asterisk="true")
    el-form-item(label='文本' prop='content')
      el-radio(v-model="form._class"
        v-for="item in MEMO_CLASS"
        :key="item.value"
        :label="item.value") {{ item.label }}
    el-form-item(label='' prop='_class')
      el-input(type="textarea"
        :rows="6"
        placeholder="请输入内容"
        v-model="form.content")
    el-form-item(label='上传附件' class='add-file')
      el-upload.upload-demo.memo-upload(ref="upload"
        :action="GLOBAL.uploadHost + 'internalMemo/upload'"
        :limit="10"
        :headers="headers"
        :on-success="success"
        multiple
        :auto-upload ="true"
        :show-file-list="false"
        :before-upload="beforeUpload"
        style="margin-right: 16px;")
        el-button(type="primary" round :size="GLOBAL.SIZE_OF_INPUTBOX") 附件
      el-input(v-model="file.fileName" placeholder="请输入文件名" style="width:360px")
      el-autocomplete.autocomplete-filename(v-model="file.path" :fetch-suggestions="querySearchAsync" placeholder='请输入文件地址' :trigger-on-focus="false" :hide-loading="true")
      el-button(type='primary' @click="addAttachments" icon="el-icon-check")
    el-form-item(label='附件列表' prop='attachments')
      .tag(v-for="(tag, tagIndex) in form.attachments" :key="tag.path")
        el-tag(size="small" style="margin-right: 10px;" closable @close='beforeRemove(tagIndex)') {{tag.fileName}}
        span {{ tag.path }}
      .tag(v-if="form.attachments.length === 0") 暂无附件
  .dialog-footer(slot="footer")
    el-button(size='small' @click="handleClose") 取消
    el-button(size='small' type='primary' @click="saveMemo") 确定
</template>
<script>
import Enum from '@/apis/enum'
import passport from '@/javascripts/passport'
import apis from '@/apis/apis'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    currentMemo: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      MEMO_CLASS: Enum.MEMO_CLASS,
      headers: passport.headers(),
      form: {
        content: '',
        _class: 0,
        attachments: []
      },
      rules: {
        content: { required: true, message: '请选择文本类型', trigger: 'change' },
        _class: { required: false, message: '请输入内容', trigger: 'blur' }
      },
      file: {
        fileName: '',
        url: ''
      }
    }
  },
  watch: {
    dialogVisible () {
      if (this.dialogVisible) {
        const { memo } = this.currentMemo
        this.form = JSON.parse(JSON.stringify(memo))
      }
    }
  },
  methods: {
    handleClose () {
      this.$emit('update:dialogVisible', false)
    },
    saveMemo () {
      if (!this.form.attachments.length && !this.form.content) {
        this.$message.warning('请输入文本或插入附件')
        return
      }
      this.$emit('updateMemo', this.form)
      this.handleClose()
    },
    // 上传成功
    success (r) {
      if (r.data) {
        this.form.attachments.push(r.data)
      } else {
        this.$message.error(r.msg)
      }
    },
    // 文件上传验证
    beforeUpload (file) {
      const isLimit = file.size / 1024 / 1024 < 100
      if (!isLimit) {
        this.$message({
          type: 'warning',
          message: '上传文件大小不能超过100MB!',
          showClose: true
        })
        return isLimit
      }
    },
    // 通过文件路径添加附件
    addAttachments () {
      if (!this.file.path || !this.file.fileName) {
        this.$message.warning('文件名和地址不能为空')
        return
      }
      this.form.attachments.push(this.file)
      this.file = {
        fileName: '',
        path: ''
      }
    },
    // 移除文件
    beforeRemove (index) {
      this.form.attachments.splice(index, 1)
    },
    querySearchAsync (querying, cb) {
      if (this.file.path === '') return
      apis.handleAutoComplete({ text: this.file.path }, '/internalMemo/getFileName').then(res => {
        const current = res.data.find(item => item.path === this.form.path)
        if (current) {
          this.$set(this.file, 'fileName', current.fileName)
        }
      })
    }
  }
}
</script>
<style scoped>
.add-file /deep/ .el-form-item__content {
  display: flex;
  align-items: center;
}
</style>
